module.exports = __webpack_public_path__ + "static/media/idea.b9763ff6.jpg";